  // Prefetch on touchstart para links del menú drawer mobile.
  // Reduce delay percibido en navegación al tocar items del menú.
  (function () {
    'use strict';

    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && conn.saveData) return;
    if (conn && /2g/.test(conn.effectiveType || '')) return;

    var prefetched = new Set();

    function prefetch(url) {
      if (!url || prefetched.has(url)) return;
      prefetched.add(url);
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }

    function shouldPrefetch(anchor) {
      if (!anchor || anchor.target === '_blank') return false;
      var href = anchor.getAttribute('href');
      if (!href || href.charAt(0) === '#') return false;
      try {
        var url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return false;
        return /^\/(collections|products|pages)\//.test(url.pathname);
      } catch (e) { return false; }
    }

    function onTouch(event) {
      var t = event.target;
      if (!(t instanceof Element)) return;
      if (!t.closest('header-drawer, .menu-drawer')) return;
      var a = t.closest('a');
      if (shouldPrefetch(a)) prefetch(a.href);
    }

    document.addEventListener('touchstart', onTouch, { passive: true, capture: true });
  })();